var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steps-header-message"},[_c('div',{staticClass:"steps-header-message__header",class:_vm.headerClasses,attrs:{"data-ci":_vm.headerClasses},domProps:{"innerHTML":_vm._s(_vm.header)}}),_vm._v(" "),_c('div',{staticClass:"steps-header-message__subheader",class:_vm.subheaderClasses,domProps:{"innerHTML":_vm._s(_vm.subheader)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }